import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

@NgModule()
export class GenericApiModule {
  constructor(@Optional() @SkipSelf() parentModule: GenericApiModule) {
    if (parentModule) {
      throw new Error('GenericApiModule is already loaded. Import it in the AppModule only!');
    }
  }

  static forRoot(): ModuleWithProviders<GenericApiModule> {
    return { ngModule: GenericApiModule };
  }
}
